import { pushToDataLayer } from '../datalayer';
import { EcommerceCartItem } from '../types';

export function trackAddToWishlist({
  currency,
  item,
  location,
}: {
  currency?: string;
  item?: EcommerceCartItem;
  location?: string;
}) {
  pushToDataLayer({
    event: 'add_to_wishlist',
    location: location || '',
    ecommerce: {
      currency: currency || '(unavailable)',
      items: [item],
    },
  });
}

export function trackRemoveFromWishlist({ currency, item }: { currency?: string; item?: EcommerceCartItem }) {
  const { item_brand, item_category, item_id, item_list_name, item_name, price } = item;
  pushToDataLayer({
    event: 'remove_from_wishlist',
    currency: currency || '(unavailable)',
    item_brand,
    item_category,
    item_id,
    item_list_name,
    item_name,
    price,
  });
}

export type Ga4TrackingType = {
  productVariants: any;
  averageProductReviewRating?: number;
  numberOfProductReviews: number;
  transformedGtmData: EcommerceCartItem;
};

export const trackWishlistAlgoliaHit = ({
  ga4,
  trackingDescriptor,
  action,
  sku,
}: {
  ga4?: Ga4TrackingType;
  trackingDescriptor: Record<string, any>;
  action: 'addItem' | 'removeItem';
  sku?: string;
}) => {
  if (!ga4 || !trackingDescriptor) return;
  const trackingFunction = action === 'addItem' ? trackAddToWishlist : trackRemoveFromWishlist;
  trackingFunction({
    currency: trackingDescriptor.currency,
    item: {
      ...ga4.transformedGtmData,
      item_review_score: ga4.averageProductReviewRating || '(unavailable)',
      item_review_count: ga4.numberOfProductReviews || '(unavailable)',
      item_list_name: trackingDescriptor.ecommerceExtraProps?.list || trackingDescriptor?.page || '(unavailable)',
      item_id: sku ? sku : ga4.transformedGtmData?.item_id,
    },
  });
};
